var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('nav-header'),_c('router-view'),_c('foot'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ba"},[_vm._v(" Copyright © 2020 Makerfire Technology Co., Ltd. All rights reserved. "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("粤ICP备17131704号")])])
}]

export { render, staticRenderFns }